import React from 'react';
import { useTranslations } from 'next-intl';

import { IOlympicList } from 'modules/online-olympic';

import TimerBox from '../timer-box';

interface IProps {
  olympic?: IOlympicList;
}

const PendingDtm: React.FC<IProps> = ({ olympic }) => {
  const t = useTranslations();

  return (
    <div className="rounded-xl bg-white p-4 sm:m-3 sm:mx-0">
      <div className="flex flex-col gap-y-2 sm:flex-row sm:items-center sm:justify-between">
        <div className="inline rounded-lg bg-red-50 p-2 text-sm font-medium text-red-500">
          {olympic?.required_subjects?.length} {t('ta_majburiy_fanlar')}
        </div>
        <TimerBox status={olympic?.status} time={olympic?.started_time} />
      </div>
      <div className="mt-5 rounded-lg bg-gray-50 p-2 font-medium">
        <div className="flex items-center justify-between">
          <p className="font-semibold">{t('fanlar')}</p>
          <p className="text-sm text-gray-700">{t('savollar_soni')}</p>
        </div>
        <hr className="!my-2 border-gray-200 bg-gray-50" />
        <div className="space-y-1 text-sm">
          {olympic?.required_subjects?.map(subject => (
            <div key={subject?.id} className="flex items-center justify-between">
              <p className="text-gray-800">{subject?.name}</p>
              <p className="text-gray-700">
                {subject?.question_count} {t('ta')}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PendingDtm;
